/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type EnumPraticaDtoStato =
  (typeof EnumPraticaDtoStato)[keyof typeof EnumPraticaDtoStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumPraticaDtoStato = {
  APERTA: 'APERTA',
  CHIUSA: 'CHIUSA',
} as const;
